export function isOdd(num: number): boolean {
  return num % 2 !== 0;
}

export function isEven(num: number): boolean {
  return num % 2 === 0;
}

export function clamp(value: number, min: number, max: number) {
  return Math.max(min, Math.min(max, value));
}

export function round(value: number, precision: number) {
  const factor = Math.pow(10, precision);
  return Math.round(value * factor) / factor;
}

export function distance(
  point: { x: number; y: number },
  rect: DOMRect
): number {
  const dx = Math.max(rect.left - point.x, 0, point.x - rect.right);
  const dy = Math.max(rect.top - point.y, 0, point.y - rect.bottom);
  return Math.hypot(dx, dy);
}
